import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import WheatTortillaProduct from 'models/WheatTortillaProduct'
import WheatTortillaPackage from './WheatTortillaPackage'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import { brandNameOptions } from './constants'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc
      initialBrandNameOptions={brandNameOptions}
      isSRPURequired={false}
    />
  ),
  packagingInfo: <WheatTortillaPackage />,
  productTitle: 'Whole Wheat Tortillas',
  model: WheatTortillaProduct,
  validCategories: ['16'],
  validSubCategories: ['008'],
  brandSpecific: false,
}

const WheatTortilla = () => <ProductForm product={productOptions} />

export default WheatTortilla

export const getWheatTortillaPackage = newProduct => {
  const newWheatTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newWheatTortillaPackage
}

export const updateWheatTortillaPackage = newProduct => {
  const newWheatTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newWheatTortillaPackage
}
